import { useCampaignStore } from '@lidea/shared/data-access/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { plotKeys } from '../../keys/plot-keys';
import { plotsApi } from './../../apis/plots-api';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UseMergePlotsProps {}

export function useMergePlots() {
  const queryClient = useQueryClient();
  const campaignId = useCampaignStore((s) => s.campaignId);
  const mutation = useMutation({
    mutationFn: plotsApi.merge,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: plotKeys.searches(campaignId),
      });
      queryClient.invalidateQueries({
        queryKey: plotKeys.inBound(campaignId),
      });
    },
  });

  return mutation;
}

export default useMergePlots;
